/** Espelha ExcluirFinanceiroVendaRequest do OrquestradorVendas (POST ProcessoVenda/idVenda/{id}/financeiro/excluir). */
export class ExcluirFinanceiroVendaRequest {
    /** Opcional (até 500 caracteres); vai para a ocorrência e para a auditoria do Finanças. */
    justificativa: string | null = null;
}
